
import { Product } from '../types';
import { storage } from '../lib/storage';

export const productService = {
  async getStoreProducts(storeId: string): Promise<Product[]> {
    const all = storage.getProducts();
    return all.filter(p => p.storeId === storeId);
  },

  async addProduct(product: Omit<Product, 'id'>): Promise<Product | null> {
    const all = storage.getProducts();
    const newProduct = { ...product, id: 'p-' + Date.now() };
    storage.saveProducts([newProduct, ...all]);
    return newProduct;
  },

  async deleteProduct(id: string): Promise<void> {
    const all = storage.getProducts();
    storage.saveProducts(all.filter(p => p.id !== id));
  },

  async updateStock(productId: string, newStock: number): Promise<boolean> {
    const all = storage.getProducts();
    const updated = all.map(p => p.id === productId ? { ...p, stock: newStock } : p);
    storage.saveProducts(updated);
    return true;
  }
};
